(() => {

const listener = () => {
  const businessType = qs('#form_business_type');
  const sole = qs('#form_sole_proprietary_or_partnership').closest('.form-group');
  const soleinps = qa('input, textarea',sole);
  const limited = qs('#form_limited_company').closest('.form-group');
  const limitedinps = qa('input, textarea',limited);
  const liability = qs('#form_limited_liability_partnership').closest('.form-group');
  const liabilityinps = qa('input, textarea',liability);

  const setReq = (inp, req) => {
    if(inp.id.indexOf('_2') === -1) {
      if(req) {
        inp.setAttribute('required',req);
      } else {
        inp.removeAttribute('required');
      }
      const l = inp.parentNode.previousElementSibling;
      if(l) {
        if(req) {
          l.classList.add('required');
        } else {
          l.classList.remove('required');
        }
      }
    }
  }

  businessType.addEventListener('change', () => {
    switch(businessType.value) {
      case 'Sole Proprietor':
      case 'Partnership':
        fe(soleinps, inp => {
          setReq(inp,true); 
        });
        sole.style.display = 'block';
        fe(limitedinps, inp => {
          setReq(inp,false); 
        })
        limited.style.display = 'none';
        fe(liabilityinps, inp => {
          setReq(inp,false); 
        })
        liability.style.display = 'none';
        break;
      case 'Limited Company':
      case 'Public Ltd. Company':
        fe(limitedinps, inp => {
          setReq(inp,true); 
        })
        limited.style.display = 'block';
        fe(soleinps, inp => {
          setReq(inp,false); 
        })
        sole.style.display = 'none';
        fe(liabilityinps, inp => {
          setReq(inp,false); 
        })
        liability.style.display = 'none';
        break;
      case 'Limited Liability Partnership':
        fe(liabilityinps, inp => {
          setReq(inp,true); 
        })
        liability.style.display = 'block';
        fe(soleinps, inp => {
          setReq(inp,false); 
        })
        sole.style.display = 'none';
        fe(limitedinps, inp => {
          setReq(inp,false); 
        })
        limited.style.display = 'none';
        break;
    }
  });

  triggerEvent(businessType, 'change');

  const products = window.getParameterByName('form_products');
  const fptn = qs('#form_products')
  if(products && fptn) {
    fptn.value = products
  }
  const price = window.getParameterByName('form_trading_details_credit_required');
  const fprn = qs('#form_trading_details_credit_required')
  if(price && fprn) {
    fprn.value = price
  }
};

if(scriptReady) { 
  listener(); 
} else { 
  if(document.addEventListener) { 
    document.addEventListener('scriptReady', listener);
  } else { 
    document.attachEvent('scriptReady', listener);
  };
}

})();